import React, { forwardRef, memo } from 'react'

const UserIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="47.6"
      height="48.3"
      viewBox="0 0 47.6 48.3"
      fill="none"
      {...props}>
      <circle cx="23.8" cy="24.5853" r="23.8" fill="#78BE20" />
      <g
        stroke="white"
        strokeWidth="2.259"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none">
        <path d="M23.8 27.2316c2.8 0 5.2763-2.4763 5.2763-5.2763S26.6 16.679 23.8 16.679s-5.2763 2.4763-5.2763 5.2763 2.4763 5.2763 5.2763 5.2763Z" />
        <path d="M15.9462 31.7138c1.7058-2.7937 4.8204-4.4822 7.8531-4.4822s6.0946 1.6885 7.8004 4.4822" />
      </g>
    </svg>
  )
)

UserIcon.displayName = 'UserIcon'

export default memo(UserIcon)
